export { formatFileSize } from "@erp/shared/utils/file/get-blob-type";
export const headers = [
    { text: "", value: "data-table-select", width: "40px" },
    { text: "폴더", value: "folder", width: "200px" },
    { text: "파일 키", value: "key" },
    { text: "크기", value: "size", width: "120px", align: "end" },
    { text: "마지막 수정", value: "lastModified", width: "180px" },
];
